export const space = {
	xs: 4,
	sm: 8,
	md: 16,
	lg: 32,
	xl: 64,
	xxl: 96,
};
